import { UserAccessLevels } from "../../../enums";
import { RefItem } from "../../../types";

export interface Room {
  room_id: number;
  customer_number: string;
  name: string;
  description: string;
  created_date: string;
  deleted_date: string;
}

export interface NonKitItem {
  nonkit_item_id: number;
  customer_number: string;
  item_number: string;
  invoice_number: string;
  shipped_date: string;
  is_tbr: number;
  active: boolean;
  status: number;
  used_date: string;
  quantity: number;
  category: string;
  ref_item: RefItem;
  waterline_inventory: WaterlineItem[];
}

export interface WaterlineInventoryResponse {
  customer_number: string;
  original_customer_number: string;
  nonkit_item_id: number;
  item_number: string;
  invoice_number: string;
  shipped_date: string | null;
  is_tbr: boolean;
  nonkit_active: boolean;
  nonkit_status: number;
  used_date: string | null;
  quantity: number;
  waterline_inventory_id: number;
  waterline_customer_number: string;
  waterline_active: boolean;
  waterline_status: number;
  room_id: number | null;
  activated_date: string | null;
  room_name: string | null;
  room_description: string | null;
  room_deleted_date: string | null;
  item_name: string;
  item_type: string;
  item_category: string;
  item_subcategory: string;
  item_images: unknown;
  item_is_backordered: boolean;
  item_is_discontinued: boolean;
  item_is_refillable: boolean;
  item_is_controlled_substance: boolean;
  item_price: number;
  item_is_sds: boolean;
  item_manufacturer_name: string | null;
  waterline_inventory_exception_id: number | null;
  exception_created_by: string | null;
  exception_created_date: string | null;
}

export interface WaterlineItem {
  id: number;
  customer_number: string;
  nonkit_item_id: number;
  room_id: number | null;
  active: boolean;
  status: number;
  activated_date: string | null;
  created_date: string;
  name?: string;
  subcategory?: string;
  item_number?: string;
  shipped_date?: string | null;
  invoice_number?: string;
  is_tbr?: boolean | string | number;
  room?: Room;
}

export interface WaterlineTestResult {
  test_result_id: number;
  hpc_method: string | null;
  product: string | null;
  cfu: string | null;
  customer_number: string;
  test_operator: string;
  is_pass: boolean;
  test_date: string | null;
  result_description: string | null;
  location: string;
  sample_number: number | null;
  retest: boolean | null;
  addressed_on?: string;
  addressed_by?: string;
  addressed_note?: string;
  pH: string | null;
  TDS: string | null;
  next_steps: string;
  receive_date: string;
  report_date?: string | null;
  room_id: number | null;
  tested_by: number | null;
  in_office_test?: boolean;
  room?: Room | null;
  test_year?: number,
  test_quarter?: number,
  is_failed_retest?: boolean,
}

export interface WaterlineMetadata {
  waterline_compliance_interval: string
}

export type DisplayResultsBy = 'roomChair' | 'testDate';

export interface WaterlineTestCompliance {
  status: number;
  message: string;
}

export const InventoryDate = {
  'Water Testing': 'Test Date',
  'Water Treatment': 'Start Date',
  'Water Straws': 'Install Date',
}

export type OpenLogResultModal = {
  open: boolean,
  testResult: WaterlineTestResult | null,
}

export type WaterlinePermissions = {
  inOffice: {
    add: UserAccessLevels[],
    edit: UserAccessLevels[],
    delete: UserAccessLevels[],
  },
  roomChair: {
    add: UserAccessLevels[],
    assign: UserAccessLevels[],
    edit: UserAccessLevels[],
    delete: UserAccessLevels[],
    view: UserAccessLevels[],
  }
}

export type WaterlineUserPermissions = {
  inOffice: {
    add: boolean,
    edit: boolean,
    delete: boolean,
  },
  roomChair: {
    add: boolean,
    assign: boolean,
    edit: boolean,
    delete: boolean,
    view: boolean,
  }
}

export type TestResultForm = Pick<
  WaterlineTestResult,
  'retest' | 'room_id' | 'result_description' | 'product' | 'hpc_method' | 'tested_by' | 'test_date' | 'sample_number' | 'pH' | 'TDS' | 'cfu' | 'report_date'
>

export type TestResultFormField = keyof TestResultForm

export type TestResultFormErrors = {
  pH: boolean,
  TDS: boolean,
  sample_number: boolean,
}

export type ReassignRoomPayload = Pick<WaterlineTestResult, 'customer_number' | 'result_description' | 'test_result_id' | 'room_id'>
